module.exports = __webpack_public_path__ + "assets/icons/accepted-nonactive-emoji.png";


//////////////////
// WEBPACK FOOTER
// ./src/styles/icons/emojies/accepted-nonactive-emoji.png
// module id = ./src/styles/icons/emojies/accepted-nonactive-emoji.png
// module chunks = 0